import * as React from 'react';

import { BrokeredLoadRecord } from '../../../types/brokeredLoad';

import { EntityTabNotes } from '~/shared/components/EntityTabNotes';

type Props = {
  load: BrokeredLoadRecord;
};

export const BrokeredLoadTabNotes: React.FC<Props> = ({ load }) => (
  <EntityTabNotes
    key={load.id}
    className="@BrokeredLoadTabNotes"
    counterparty="customer"
    isReadonly
    internalNotes={load.recyclerInternalNotes ?? ''}
    externalNotes={load.recyclerExternalNotes ?? ''}
  />
);
